import { createSlice } from "@reduxjs/toolkit";
import { createExportInvoicePdfThunk } from "../components/Invoices/thunks/invoiceThunks";
import { cWingsServiceBaseURL } from "../../config/Api.config"; // your Service B base URL
import AppConstants from "constants/AppConstants";
import { SharedState } from "./sharedSlice.types";

// Create the thunk scoped to this slice and service
export const exportInvoicePdf = createExportInvoicePdfThunk(
  "sharedSlice",
  cWingsServiceBaseURL
);

const initialState: SharedState = {
  loading: false,
  invoiceData: undefined,
  displayInvoice: false,
  error: "",
};

const sharedSlice = createSlice({
  name: "sharedSlice",
  initialState,
  reducers: {
    resetInvoiceState: (state) => {
      state.loading = false;
      state.invoiceData = undefined;
      state.displayInvoice = false;
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(exportInvoicePdf.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.invoiceData = undefined;
        state.displayInvoice = false;
      })
      .addCase(exportInvoicePdf.fulfilled, (state, action) => {
        const data = action.payload?.invoices;
        state.loading = false;
        if (data?.length) {
          state.displayInvoice = true;
          state.invoiceData = data[0];
        }
      })
      .addCase(exportInvoicePdf.rejected, (state, action) => {
        const errorPayload: any = action.payload;
        state.loading = false;
        state.displayInvoice = false;
        state.invoiceData = undefined;
        state.error = errorPayload
        ? errorPayload.message
        : AppConstants.RESPONSE_CONSTANTS.DEFAULT_API_FAILED_ERROR_MSG;
      });
  },
});

export const { resetInvoiceState } = sharedSlice.actions;
export default sharedSlice.reducer;
